<div *ngIf="data?.rcList?.length" class="w-100 d-block">
    <app-ag-grid-wrapper #grid 
        (gridReady)="onGridReady($event)"
        (rowSelected)="onRowSelected($event)"
        [gridConfig]='gridOptions' [rowData]="data.rcList" 
        [columnDefs]="columnDefs" 
        [frameworkComponents]='frameworkComponents'
        [context]='context' (gridReady)="onGridReady($event)">
    </app-ag-grid-wrapper>
</div>